
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselGenericFastFilled as ObiVesselGenericFastFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-generic-fast-filled.js';
 
 
 

 
 export const ObiVesselGenericFastFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-generic-fast-filled',
   elementClass: ObiVesselGenericFastFilledElement,
   events: {
     
   }
  });
 
 